import './css/sidenav.css';
import React, { useState,useEffect} from "react";
import axios from '../../config/index';
import {Link, useNavigate} from 'react-router-dom';
import { useLocation } from "react-router-dom";

import Logo from '../images/whitelogo.png';





function SideNav(props){

    
const navigate = useNavigate();
const [showUserOptions, setShowUserOptions] = useState(false);
const [user, setUser] = useState('');
const location = useLocation();

const [userDataLoaded, setUserDataLoaded] = useState(false); // New state variable




axios.defaults.withCredentials = true;


const logout = () => {
    axios
    .get('logout')
    .then((res) => {
        if (res.data.logout) {
            props.setSessionExists(false);
        navigate('/admin-login');

        } else {
        navigate('/admin-login');
        }
    })
    .catch((err) => console.log(err));
};


const handleUserOptionsClick = () => {
    setShowUserOptions(!showUserOptions);
};

const getUser = (userId) => {
    console.log(userId);
    axios
    .post('user', { userId })
    .then((res) => {
        if (res.data.message) {
            console.log(res.data.message);

        } else {
            setUser(res.data);
            setUserDataLoaded(true); 

        }
    })
    .catch((err) => console.log(err));

};


const openCloseNav = ()=>{
    let SideNav = document.querySelector(".sidenav");
    let searchBar = document.querySelector(".search-bar");
    let dashboard = document.querySelector(".dashboard");

    if(SideNav.classList.contains("active")){
        SideNav.classList.remove("active");
        searchBar.classList.remove("active");
        dashboard.classList.remove("active");
    }else{
        SideNav.classList.add("active");
        searchBar.classList.add("active");
        dashboard.classList.add("active");
    }
    

}


useEffect(() => {
    axios
    .get('session')
    .then((res) => {
        if (res.data.valid) {
            props.setSessionExists(true);
            getUser(res.data.userId);
            setUserDataLoaded(true); 

            console.log(userDataLoaded);

        } else {
            props.setSessionExists(false);
            getUser(0);
            console.log(userDataLoaded);

        }
    })
    .catch((err) => console.log(err));
}, [props.sessionExists]);













    return(
        <>
            
            <div  className={`${props.className} sidenav`}>
                <button onClick={openCloseNav} className='open-close-nav'> <i class="las la-bars"></i> </button>
                <div className="sidenav-content">
                    <div className="user-info">
                    {userDataLoaded && props.sessionExists ? (
                        <>
                            <img src={Logo} alt="logo" />
                                <h1>   Welcome Back</h1>
                        </>
                            ):null}
                    </div>
                


                <div className='sidenav-elements'>
                    <ul>
                    

                        <li className={location.pathname === "/dashboard"? 'active':null}>
                            <Link to="/dashboard">
                            <i class="las la-home"></i>
                                Dashboard
                            </Link>
                        </li>

                        
                        
                        <li className={location.pathname === "/all-users"? 'active':null}>
                            <Link to="/all-users">
                                <i class="las la-poll-h"></i>
                                All Users
                            </Link>
                        </li>

                        
                        <li className={location.pathname === "/all-landing-text"? 'active':null}>
                            <Link to="/all-landing-slides">
                                <i class="las la-poll-h"></i>
                                Home Main Text
                            </Link>
                        </li>

                                                
                        <li className={location.pathname === "/all-about"? 'active':null}>
                            <Link to="/all-about">
                                <i class="las la-poll-h"></i>
                                About Section
                            </Link>
                        </li>

                        <li className={location.pathname === "/all-benefits"? 'active':null}>
                            <Link to="/all-benefits">
                                <i class="las la-poll-h"></i>
                                Benefits Section
                            </Link>
                        </li>

                        <li className={location.pathname === "/all-solutions"? 'active':null}>
                            <Link to="/all-solutions">
                                <i class="las la-poll-h"></i>
                                Solution Section
                            </Link>
                        </li>


                        <li className={location.pathname === "/all-categories"? 'active':null}>
                            <Link to="/all-categories">
                                <i class="las la-poll-h"></i>
                                Services Categories
                            </Link>
                        </li>


                        <li className={location.pathname === "/all-services"? 'active':null}>
                            <Link to="/all-services">
                                <i class="las la-poll-h"></i>
                                Services
                            </Link>
                        </li>


                        <li className={location.pathname === "/all-blogs"? 'active':null}>
                            <Link to="/all-blogs">
                                <i class="las la-poll-h"></i>
                                Blogs
                            </Link>
                        </li>

                        
                        <li className={location.pathname === "/all-jobs"? 'active':null}>
                            <Link to="/all-jobs">
                                <i class="las la-poll-h"></i>
                                Jobs
                            </Link>
                        </li>



                        
                        <li className={location.pathname === "/all-social"? 'active':null}>
                            <Link to="/all-social">
                                <i class="las la-poll-h"></i>
                                Social Media & Links
                            </Link>
                        </li>



                        <li>
                            <Link to="/">
                                <i class="las la-search"></i>
                                View Website
                            </Link>
                        </li>




                        <li>
                            <button onClick={logout}>
                                <i class="las la-sign-out-alt"></i>
                                Logout
                            </button>
                        </li>

                    


                    </ul>
                </div>
            </div>
            </div>
        
        </>
    )
}

export default SideNav;